export default __webpack_public_path__ + "static/media/caret-right-fill.9bd49a27.svg";